<ng-container *transloco="let t; read: 'RELOAD_BUTTON_COMPONENT'">
  <ng-container *ngLet="accountBalanceDS$ | async as accountBalanceDS">
    <ion-button
      *ngLet="hasBalanceAlert(accountBalanceDS.data!) as hasBalanceAlert"
      [routerLink]="link"
      fill="clear"
      class="rounded amount-wrapper"
      [class.has-warning]="hasBalanceAlert && !accountBalanceDS.loading"
    >
      <app-pre-loader *ngIf="accountBalanceDS.loading; else balanceLoaded"> </app-pre-loader>

      <ng-template #balanceLoaded>
        <ng-container *ngIf="accountBalanceDS.data !== undefined && !accountBalanceDS.error; else balanceError">
          <span [class.warning]="hasBalanceAlert">
            <app-currency [value]="accountBalanceDS.data"></app-currency>
          </span>
          <span
            *ngIf="(isReloadTextShowable | async) && (hasBalanceAlert || showReloadTextWithoutWarning)"
            [class.warning]="hasBalanceAlert"
            [innerHTML]="t('RELOAD')"
          ></span>
        </ng-container>

        <ng-template #balanceError>
          <span class="warning-color">NC</span>
        </ng-template>
      </ng-template>
    </ion-button>
  </ng-container>
</ng-container>
